import { GRAY_700, GRAY_900 } from 'constants/styling/theme'
import { Stack, Typography } from '@mui/material'

import { BorderBoxWrapper } from 'components/common/BorderBoxWrapper'
import { MUIButton } from 'components/common/MUIButton'
import React from 'react'
import { externalNavigate } from 'utils/helpers'
import { getPricingUrl } from 'utils/localization'
import i18n from 'translations/i18n'
import { logAnalyticsEvent } from 'utils/analytics'
import { useTranslation } from 'react-i18next'
import { useUserData } from 'components/contexts/UserDataContext'

/**
 * @component User Did you know information displayed in Profile page
 * @example
 * <DidYouKnowRedesign userData={userMeRequest.data} />
 */
export const DidYouKnowRedesign: React.FC = () => {
  const { t } = useTranslation(['profile'])
  const { clientData } = useUserData()

  return (
    <BorderBoxWrapper padding={2.4} gap={1.6} display="inline-grid">

      <Stack gap={1.6} alignItems="flex-start" justifyContent="space-between">

        <Typography variant="text-xl" fontWeight={600} color={GRAY_900}>
          {t('did_you_know.title')}
        </Typography>

        <Typography variant="text-sm" fontWeight={400} color={GRAY_700}>
          {t('did_you_know.description')}
        </Typography>

      </Stack>

      <Stack alignItems="flex-end">
        <MUIButton
          onClick={() => {
            logAnalyticsEvent('unblock_saas_profile_page', {
              userEmail: clientData?.email,
              organizationId: clientData?.organizationId,
            })
            externalNavigate(getPricingUrl(i18n.language))
          }}
        >
          {t('did_you_know.button')}
        </MUIButton>
      </Stack>

    </BorderBoxWrapper>
  )
}
